const API_BASE = process.env.REACT_APP_API_URL || '/api/v1'

function getToken() {
    try {
        const raw = localStorage.getItem('abhaflow-auth')
        if (!raw) return null
        const parsed = JSON.parse(raw)
        return parsed?.state?.backendToken || null
    } catch { return null }
}

async function exchangeToken() {
    try {
        const raw = localStorage.getItem('abhaflow-auth')
        if (!raw) return null
        const parsed = JSON.parse(raw)
        const supabaseToken = parsed?.state?.session?.access_token
        if (!supabaseToken) return null

        const res = await fetch(`${API_BASE}/auth/exchange`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ supabase_token: supabaseToken }),
        })
        if (!res.ok) return null
        const json = await res.json()
        if (!json.success) return null

        parsed.state.backendToken = json.data.token
        parsed.state.backendRefreshToken = json.data.refreshToken
        localStorage.setItem('abhaflow-auth', JSON.stringify(parsed))
        return json.data.token
    } catch { return null }
}

async function refreshBackendToken() {
    try {
        const raw = localStorage.getItem('abhaflow-auth')
        if (!raw) return null
        const parsed = JSON.parse(raw)
        const refreshToken = parsed?.state?.backendRefreshToken
        if (!refreshToken) return null

        const res = await fetch(`${API_BASE}/auth/refresh`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
        })
        if (!res.ok) return null
        const json = await res.json()
        if (!json.success) return null

        parsed.state.backendToken = json.data.token
        parsed.state.backendRefreshToken = json.data.refreshToken
        localStorage.setItem('abhaflow-auth', JSON.stringify(parsed))
        return json.data.token
    } catch { return null }
}

export async function apiRequest(method, path, body = null) {
    let token = getToken()

    if (!token) {
        token = await exchangeToken()
        if (!token) throw new Error('Authentication required')
    }

    const opts = {
        method,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }
    if (body && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
        opts.body = JSON.stringify(body)
    }

    const res = await fetch(`${API_BASE}${path}`, opts)
    if (res.status === 401) {
        const newToken = await refreshBackendToken()
        if (!newToken) throw new Error('Session expired')
        opts.headers.Authorization = `Bearer ${newToken}`
        const retry = await fetch(`${API_BASE}${path}`, opts)
        const json = await retry.json()
        if (!json.success) throw new Error(json.message || 'Request failed')
        return json.data
    }
    const json = await res.json()
    if (!json.success) throw new Error(json.message || 'Request failed')
    return json.data
}
